import { Box, Stack, Typography } from "@mui/material";
import { useContext } from "react";

import { useTranslation } from "react-i18next";
import { ColorScheme } from "../../../Themes/ColorScheme";
import { ApiContext } from "../../ApiContext";
import { ConfirmAction } from "../../Common/ConfirmAction";
import { UserContext } from "../../UserContext";

export const ClientCard = ({ manager, refresh }) => {
	const debug = false;

	const { user } = useContext(UserContext);

	const { t } = useTranslation();
	const { ApiCall } = useContext(ApiContext);

	const handleUserRemove = () => {
		ApiCall("POST", "client/manager/remove/" + manager.id)
			.then(() => refresh())
			.catch((error) => {
				if (debug) console.log(error);
			});
	};

	return (
		<Stack
			sx={{
				padding: "15px",
				overflow: "auto",
				backgroundColor: ColorScheme.secondary,
				borderRadius: "4px",
				marginBottom: "10px",
				flexDirection: "row",
				justifyContent: "space-between",
				display: "flex"
			}}
		>
			<Box sx={{ flexDirection: "column", display: "flex" }}>
				<Typography
					style={{
						fontSize: "12px",
						color: ColorScheme.black,
						fontWeight: "700"
					}}
				>
					{manager.manager_name}
				</Typography>
				<Typography
					style={{
						fontSize: "10px",
						color: ColorScheme.textSecondary,
						fontWeight: "300"
					}}
				>
					{manager.manager_email}
				</Typography>
				{!manager.accepted_invitation && (
					<Typography
						style={{
							fontSize: "10px",
							color: ColorScheme.dangerPrimary,
							fontWeight: "300"
						}}
					>
						{t("location.form_location_admin_pending")}
					</Typography>
				)}
			</Box>
			{user.email !== manager.manager_email && (
				<ConfirmAction
					handleTitle={t("buttons.remove_user_admin_rights")}
					isIconButton={true}
					handleConfirmAction={handleUserRemove}
				/>
			)}
		</Stack>
	);
};
